import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'auth/login',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'auth/register',
    loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./features/auth/callback/auth-callback.component').then(m => m.AuthCallbackComponent)
  },
  {
    path: 'auth/callback/google',
    loadComponent: () => import('./features/auth/callback/auth-callback.component').then(m => m.AuthCallbackComponent)
  },
  {
    path: 'auth/callback/facebook',
    loadComponent: () => import('./features/auth/callback/auth-callback.component').then(m => m.AuthCallbackComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./features/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./features/auth/verify-email/verify-email.component').then(m => m.VerifyEmailComponent)
  },
  {
    path: 'privacy',
    loadComponent: () => import('./features/legal/privacy/privacy.component').then(m => m.PrivacyComponent)
  },
  {
    path: 'terms',
    loadComponent: () => import('./features/legal/terms/terms.component').then(m => m.TermsComponent)
  },
  {
    path: 'data-deletion',
    loadComponent: () => import('./features/legal/facebook-data-deletion/facebook-data-deletion.component').then(m => m.FacebookDataDeletionComponent)
  },
  {
    path: 'facebook/data-deletion',
    redirectTo: 'data-deletion',
    pathMatch: 'full'
  },
  {
    path: 'session',
    canActivate: [authGuard],
    loadChildren: () => import('./features/session/session.routes').then(m => m.sessionRoutes)
  },
  {
    path: 'mission',
    loadChildren: () => import('./features/mission/mission.routes').then(m => m.missionRoutes),
    canActivate: [authGuard]
  },
  {
    path: 'saved-lists',
    title: 'Saved Lists',
    canActivate: [authGuard],
    loadComponent: () => import('./features/saved-lists/saved-lists.component').then(m => m.SavedListsComponent)
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.adminRoutes)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
